import * as React from 'react';
import { cn, getText } from '../../helpers';

const sortBy = getText('generic.sortBy');
const DataSortOptions = function DataSortOptions(props: DataSortOptionsProps) {
    const { queryString, sortOptions, updateQueryString } = props;

    return (
        <div className="data-sort__options">
            <div className="page-section">
                <div className="collapse data-sort__title-container page-section__inner">
                    <h5 className="data-sort__title">{sortBy}</h5>
                </div>
                <div className="page-section__inner">
                    {sortOptions.map(data => (
                        <button
                            type="button"
                            key={data.text}
                            className={cn('data-sort__option', { 'data-sort__option--active': queryString === data.id })}
                            title={data.text}
                            onClick={() => updateQueryString('sort', data.id)}
                        >
                            {data.text}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default React.memo(DataSortOptions);
